module.exports = __webpack_public_path__ + "static/media/a_default_earth.aa622bd4.jpg";